import BaseDialog from "@/components/BaseDialog";

// 创意团队规则
export function teamRuleModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./teamRuleModal.vue'),
        options: {
            width: '650px',
            title: props.id?'编辑团队规则':'添加团队规则',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 投放尺寸规则
export function sizeRuleModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./sizeRuleModal.vue'),
        options: {
            width: '1050px',
            title: props.id?'编辑投放尺寸':'添加投放尺寸',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 一级标签
export function label1Modal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./label1Modal.vue'),
        options: {
            width: '600px',
            title: props.id?'编辑一级标签':'添加一级标签',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 二级标签
export function label2Modal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./label2Modal.vue'),
        options: {
            width: '600px',
            title: props.id?'编辑二级标签':'添加二级标签',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
// 工单标签
export function workOrderTagModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./workOrderTagModal.vue'),
        options: {
            width: '600px',
            title: props.row.id?'编辑工单标签':'添加工单标签',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
// 添加部门
export function addDepartmentModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./addDepartmentModal.vue'),
        options: {
            width: '800px',
            title: '添加部门',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
// 修改产能
export function editCapacityModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./editCapacityModal.vue'),
        options: {
            width: '600px',
            title: '修改产能',
        },
        props,
        cbs,
    })
}
// 历史修改记录
export function capacityHistoryModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./capacityHistoryModal.vue'),
        options: {
            width: '600px',
            title: '历史修改记录',
        },
        props,
        cbs,
    })
}